<template>
    <button type="button" class="d-none" data-toggle="modal" data-target=".usersProfileModals" id="addProfileBtn"> </button>
    <div class="modal fade usersProfileModals" id="userModalId" tabindex="-1" role="dialog"  aria-hidden="true">
        <div class="modal-dialog modal-lg datasearchpartuser ">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Profile</h5>
                    <button type="button" class="close" id="closeProfilePop" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="form-group col-md-12">
                            <span v-if="errorMessage != ''">
                                <p class="alert alert-danger error-msg" >{{ errorMessage }}</p>
                            </span>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="teamProfileName">Name:</label>
                            <input type="text" class="form-control" name="teamName" id="teamProfileName" placeholder="Enter name"  v-model="v$.form.teamName.$model"> 
                            <div class="input-errors" v-for="(error, index) of v$.form.teamName.$errors" :key="index">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="teamProfileEmail">Email:</label>
                            <input type="email" class="form-control" name="teamEmail" id="teamProfileEmail" placeholder="Enter email"  v-model="v$.form.teamEmail.$model"> 
                            <div class="input-errors" v-for="(error, index) of v$.form.teamEmail.$errors" :key="index">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="passwordProfileEdit">Password:</label>
                            <input type="password" class="form-control" name="passwordEdit" id="passwordProfileEdit" placeholder="Enter password"  v-model="v$.form.teamPassword.$model"> 
                            <div class="input-errors" v-for="(error, index) of v$.form.passwordEdit.$errors" :key="index">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                        <!-- <div class="form-group col-md-6 uploadshrtcls">
                                <label for="user_image_profile" >User Image</label>
                                <div class="formmginput-controlx_inner fileintset setfileupload d-flex justify-content-between">
                                    <input type="file" class="form-control" name="user_image" id="user_image_profile" accept="image/png, image/gif, image/jpeg" @change="readURL()">
                                    <div class="iq-avatars d-flex flex-wrap align-items-center">
                                        <img id="blahProfile" src="../../assets/images/No_image_available.svg.png" alt="logo image" class="avatar-40 rounded" />
                                        <input type="hidden" value="../assets/No_image_available.svg.png" id="imgVal" />
                                    </div>
                                </div>       
                        </div>  -->    
                        <div class="form-group col-md-6 uploadshrtcls">
                                <label for="user_image_profile" >User Image</label>
                                <div class="upload-btn-wrapper">
                                    <div class="formmginput-controlx_inner fileintset setfileupload d-flex justify-content-between">
                                        <input type="file" class="form-control" name="user_image" id="user_image_profile" accept="image/png, image/gif, image/jpeg" @change="readURL()">Upload a file
                                        <div class="iq-avatars d-flex flex-wrap align-items-center">
                                            <img id="blahProfile" src="../../assets/images/No_image_available.svg.png" alt="logo image" class="avatar-40 rounded" />
                                            <input type="hidden" value="../assets/No_image_available.svg.png" id="imgVal" />
                                        </div>
                                    </div> 
                                </div>      
                            <!-- <div class="input-errors">
                                <div class="error-msg  nonecls" id="imgErrorCls">Please select image</div>
                            </div> -->
                        </div>  
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="submit" class="btn btn-primary" :disabled="v$.form.$invalid" v-on:click="addUser" v-if="formLoader === 1">{{ buttonName }}</button>
                    <button type="button" class="btn btn-primary" :disabled="v$.form.$invalid" v-else><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import useVuelidate from '@vuelidate/core'
// import axios from 'axios'
import {
        startLoader,
        finishLoader
} from '../../utils/helper.js'

import {
    email,
    required,
    // maxLength,
    minLength
} from '@vuelidate/validators'
import 
    { postCommon } 
from '../../utils/api.js'
import $ from "jquery";
    export default {
        name: 'ProfilePage',

        data() {
            return {
                modalType: 'Add',
                buttonName: 'Save',
                errorMessage: '',
                formLoader: 1,
                logoFile: null,
                img_url: process.env.VUE_APP_IMG_URL,
                form: {
                    teamName: '',
                    teamEmail: '',
                    teamPassword: '',
                    user_image: '',
                    password: '',
                    passwordEdit: '',
                },
            }
        },
        methods: {
            startLoader,
            finishLoader,
            async profileUpdate() {
                this.startLoader();
                let team_id = this.$store.state.user.userInfo._id;
                this.errorMessage = ''
                this.form.teamName = '';
                this.form.lastName = '';
                this.form.teamEmail = '';
                this.form.passwordEdit = '';
                this.modalType = 'Edit',
                this.buttonName = 'Update',
                document.getElementById('teamProfileName').value = '';
                document.getElementById('teamProfileEmail').value = '';
                this.v$.$reset()
                this.formLoader = 2

                let _post = {}
                _post = {
                    user_id: team_id
                }

                const resp = await postCommon('user/get', _post)
                if (resp.status == 200 && resp.data.status == 'success') {
                    document.getElementById('teamProfileName').value = resp.data.data.name;
                    document.getElementById('teamProfileEmail').value = resp.data.data.email;
                    // document.getElementById('teamEditId').value = resp.data.data._id;
                    this.v$.form.teamName.$model = resp.data.data.name;
                    // this.v$.form.teamPassword.$model = resp.data.data.email;
                    this.v$.form.teamEmail.$model = resp.data.data.email;
                    document.getElementById('blahProfile').src = this.img_url + '' + resp.data.data.user_image
                    document.getElementById('addProfileBtn').click();
                    this.v$.$reset()
                    this.finishLoader();
                    setTimeout(async () =>
                        $("#teamProfileName").focus(),
                    500);
                }
                this.formLoader = 1
            },
            async addUser() {
                this.formLoader = 2
                let _URL = ''
                
                const fd = new FormData;

                var teamName = $('#teamProfileName').val();
                var teamEmail = $('#teamProfileEmail').val();
                var teamPassword = $('#passwordProfileEdit').val();

                fd.append('name', teamName)
                fd.append('email', teamEmail)
                fd.append('user_image', this.logoFile)
                // let _post = {}
                if (this.modalType == 'Edit') {
                    _URL = 'user/update'       
                    if(teamPassword){
                        fd.append('password', teamPassword)         
                    }
                    fd.append('user_id', this.$store.state.user.userInfo._id)    
                }
                const resp = await postCommon(_URL, fd)

                if (resp.status == 200 && resp.data.status == 'success') {
                    document.getElementById('closeProfilePop').click();
                    this.$toast.success(resp.data.message);
                } else if (resp.status == 200 && resp.data.status == 'failure') {
                    this.errorMessage = resp.data.message;
                }
                    this.formLoader = 1
            },
            readURL() {
                this.logoFile = document.getElementById('user_image_profile').files[0]
                var selectedFile = document.getElementById('user_image_profile').files[0];
                var img = document.getElementById('blahProfile')
                var reader = new FileReader();
                reader.onload = function () {
                    img.src = this.result
                }
                this.isNewImg = 1;
                // document.getElementById('imgErrorCls').style.display = 'none';

                if(selectedFile){
                    reader.readAsDataURL(selectedFile);
                }

            },
        },
    setup() {
        return {
            v$: useVuelidate()
        }
    },
    validations() {
        return {
            form: {
                teamName: {
                    required,
                    min: minLength(2)
                },
                teamEmail: {
                    email,
                    required,
                },
                teamPassword: {
                    min: minLength(8)
                },
                passwordEdit: {
                    min: minLength(8)
                },
            },
        }
    },
    }
</script>
